/* eslint-disable import/prefer-default-export */
import Backdrop from '@mui/material/Backdrop';
import { styled } from '@mui/material/styles';

export const CustomBackdrop = styled(Backdrop)(() => ({
  color: '#fff',
  zIndex: (theme) => theme.zIndex.drawer + 1,
}));
